"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var styles_1 = require("@mui/material/styles");
var __1 = require("../..");
exports.default = (0, styles_1.styled)(function (props) { return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ arrow: true, componentsProps: {
        tooltip: {
            style: {
                backgroundColor: __1.theme.palette.primary[600],
                fontSize: '1.2rem',
                borderRadius: '0.8rem',
                padding: '0.4rem 1.2rem',
                marginTop: '0.8rem !important',
            },
        },
        arrow: {
            style: {
                color: __1.theme.palette.primary[600],
            },
        },
    } }, props, { children: props.children }))); })();
